<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <div class="content-title content-mb-14">
      21. Письмо-заверение об отсутствии гостайны
    </div>
    <div style="width: 700px">
      <a
        class="btn btn-default pull-right"
        :href="siteUrl + 'images/no_gostainadata.docx'"
        target="_blank"
        >Скачать шаблон</a
      >
      <br />
      <br />
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Наименование документа</th>
            <th>Формат</th>
            <th>Дата загрузки</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span v-if="project.UF_FILE_NO_GOSTAINA == ''"
                >Письмо-заверение об отсутствии гостайны</span
              >
              <a
                class="doc-link"
                style="text-decoration: underline;"
                v-else
                :href="
                  siteUrl.replace(new RegExp('[\/]+$'), '') +
                    project.UF_FILE_NO_GOSTAINA
                "
                target="_blank"
                >Письмо-заверение об отсутствии гостайны</a
              >
            </td>
            <td>PDF</td>
            <td>{{ project.UF_LOAD_F_NO_GOSTAIN }}</td>
          </tr>
        </tbody>
      </table>
      Письмо-заверение готовится на фирменном бланке, заверяется подписью
      уполномоченного лица и печатью организации<br /><br />
      <div>
        <div style="display: inline-block">
          <input
            type="file"
            ref="file"
            @change="onChange"
            accept=".pdf"
            style="display: none"
          />
          <button
            type="button"
            @click="$refs.file.click()"
            class="btn btn-success"
          >
            Загрузить документ
          </button>
        </div>
        <div style="display: inline-block">&nbsp;&nbsp;&nbsp;{{ uFile }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { AUTH_URL } from "@/common/config";

export default {
  name: "step2",
  props: ["step", "project"],
  data() {
    return {
      siteUrl: "",
      uFile: ""
    };
  },
  created() {
    this.siteUrl = AUTH_URL;
  },
  methods: {
    onChange(e) {
      let files = e.target.files;

      for (var i = 0; i < files.length; i++) {
        let file = files[i];

        let reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
          // Make a fileInfo Object
          let fileInfo = {
            name: file.name,
            type: file.type,
            size: Math.round(file.size / 1000) + " kB",
            base64: reader.result,
            file: file
          };
          this.uFile = file.name;

          this.project.UF_FILE_NO_GOSTAINA_FILE = fileInfo.base64;
        }; // reader.onload
      } // for
    }
  }
};
</script>

<style scoped></style>
